import { BlogCategoryApiService } from '@/core';
import { Component, inject } from '@angular/core';
import { CacTableComponent, table } from '@controladad/ng-base';
import { BlogCategoryEntity } from '@repo/types';

@Component({
  selector: 'app-blog-categories',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './blog-categories.component.html',
  styleUrl: './blog-categories.component.scss',
})
export class BlogCategoriesComponent {
  private readonly blogCategoryApi = inject(BlogCategoryApiService);

  table = table({
    itemsFn: this.blogCategoryApi.getAdapter(),
    view: {
      itemName: 'blogCategory',
    },
    columns: {
      id: { label: 'ID' },
      name: { label: 'Title' },
      type: {
        label: 'Type',
        transform: (v) => (v == 0 ? 'Others' : 'Blog'),
        filterable: [
          {
            type: 'equal',
            key: 'Type',
            controlType: 'select',
            items: [
              { value: 0, label: 'Others' },
              { value: 1, label: 'Blog' },
            ],
          },
        ],
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: BlogCategoryEntity) => dialog$.blogCategory({ blogCategory: item }).afterSubmit(),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item) => dialog$.deletePrompt(true).action(() => this.blogCategoryApi.deleteBlogCategory(item.id)),
      },
    ],
    events: {
      add: () => dialog$.blogCategory().afterSubmit(),
    },
  });
}
